<template>
  <div class="component-checkboxes-dropdown">
    <label class="fs-12 mb-2" v-if="label">
      {{ label }}
    </label>
    <b-dropdown no-caret block offset="0,8px" :disabled="disabled">
      <template #button-content>
        <div class="options-container" v-if="innerValue.length && !allChecked">
          <div
            class="removable-option"
            v-for="option in innerValue"
            :key="option"
          >
            <div class="option-name">
              {{ optionName(option) }}
            </div>
            <button class="btn btn-sm" @click.stop="removeOption(option)">
              <i class="fa fa-close" />
            </button>
          </div>
        </div>
        <div class="options-placeholder" v-else>
          <span v-if="!innerValue.length">
            {{ placeholder }}
          </span>
          <span v-else-if="allChecked">
            {{ masculine ? "Todos" : "Todas" }}
          </span>
        </div>
        <i class="fa fa-angle-down pl-3" />
      </template>

      <slot>
        <div v-if="!options.length" class="text-secondary">
          Não há opções
        </div>

        <template v-else>
          <b-checkbox
            v-model="allChecked"
            class="py-2"
            @change="checkAllOptions"
            :disabled="allChecked"
          >
            {{ masculine ? "Selecionar todos" : "Selecionar todas" }}
          </b-checkbox>

          <hr class="my-3 border-neutral-076" />

          <b-checkbox-group stacked v-model="innerValue">
            <div v-for="option in options" :key="option.id">
              <b-checkbox class="py-2" :value="option.id">
                {{ option.name }}
              </b-checkbox>
              <span class="option-description" v-if="option.description">
                {{ option.description }}
              </span>
            </div>
          </b-checkbox-group>

          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-sm p-0 text-primary"
              @click.prevent="uncheckAllOptions"
            >
              Limpar
            </button>
          </div>
        </template>
      </slot>
    </b-dropdown>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Selecione as opções"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    masculine: {
      type: Boolean,
      default: false
    },
    allButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: this.value,
      allChecked: this.value.length === this.options.length
    };
  },
  methods: {
    checkAllOptions(v) {
      this.innerValue = v ? [...this.options.map(opt => opt.id)] : [];
    },
    uncheckAllOptions() {
      this.innerValue = [];
    },
    optionName(option) {
      return (this.options.find(opt => opt.id === option) || {})?.name;
    },
    removeOption(option) {
      this.innerValue = this.innerValue.filter(opt => opt !== option);
    }
  },
  watch: {
    innerValue(v) {
      if (v.length !== this.options.length && this.allChecked)
        this.allChecked = false;
      else if (v.length === this.options.length) this.allChecked = true;
      this.$emit("input", v);

      let changedValues = {};
      this.options.forEach(option => {
        let id = option.id;
        changedValues[id] = v.includes(id);
      });
      this.$emit("change", changedValues);
    }
  }
};
</script>
<style lang="scss" scoped>
.component-checkboxes-dropdown {
  position: relative;
  label {
    color: #736d80;
  }

  .options-placeholder {
    flex: 1;
    display: block;
    overflow: hidden;
    text-align: left;
    white-space: pre-wrap;
  }
  .option-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(119, 120, 142, 0.87);
  }
  .options-container {
    flex: 1;
    gap: 6px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .removable-option {
      padding: 1px 4px;
      background-color: #f4f4f5;
      border: 1px solid #e9e9eb;
      color: #909399;
      border-radius: 8px;
      display: flex;
      max-width: 100%;
      width: min-content;
      overflow: hidden;
      align-items: center;
      justify-content: space-between;
      cursor: default;
      font-size: 12px;
      .option-name {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      button {
        border-radius: 50px;
        color: #909399;
        background-color: #c0c4cc;
        padding: 0;
        width: 16px;
        font-size: 12px;
        aspect-ratio: 1;
        margin-left: 4px;
        cursor: pointer;
        i {
          font-weight: 300;
        }
        &:hover {
          color: #fff;
          background-color: #909399;
        }
      }
    }
  }

  ::v-deep {
    .b-dropdown {
      .dropdown-toggle {
        font-size: 14px;
        min-height: 40px;
        padding: 8px 12px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: normal;
        color: #5a5466;
        background-color: unset;
        border-color: #c4c0cc;
        &:is(:hover, :active):not(:disabled) {
          border-color: #77788edd;
        }
        &:disabled {
          cursor: not-allowed;
          background-color: #f5f7fa;
          border-color: #c4c0cc;
          color: #c0c4cc;
        }
      }
      &.show {
        .dropdown-toggle {
          cursor: default;
        }
      }
      .dropdown-menu {
        width: 100%;
        max-width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
          background-color: #fff;
          border-radius: 0 4px 4px 0;
        }
        &::-webkit-scrollbar-thumb {
          height: 10px;
          border-radius: 10px;
          border: 5px solid white;
          background-color: #928f98;
        }

        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid rgba(219, 221, 230, 0.85);
        .custom-control-label {
          font-size: 14px;
          line-height: 1.75;
        }
        button {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
